/**
 * 全角英数字を半角に変換
 * @param text
 * @returns
 */
export const englishNumberToHalfWidth = (text: string): string => {
  return text.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0))
}

/**
 * 全角カナを半角に変換
 * @param text
 * @returns
 */
export const kanaToHalfWidth = (text: string): string => {
  const kanaMap = new Map<string, string>([
    ['ガ', 'ｶﾞ'],
    ['ギ', 'ｷﾞ'],
    ['グ', 'ｸﾞ'],
    ['ゲ', 'ｹﾞ'],
    ['ゴ', 'ｺﾞ'],
    ['ザ', 'ｻﾞ'],
    ['ジ', 'ｼﾞ'],
    ['ズ', 'ｽﾞ'],
    ['ゼ', 'ｾﾞ'],
    ['ゾ', 'ｿﾞ'],
    ['ダ', 'ﾀﾞ'],
    ['ヂ', 'ﾁﾞ'],
    ['ヅ', 'ﾂﾞ'],
    ['デ', 'ﾃﾞ'],
    ['ド', 'ﾄﾞ'],
    ['バ', 'ﾊﾞ'],
    ['ビ', 'ﾋﾞ'],
    ['ブ', 'ﾌﾞ'],
    ['ベ', 'ﾍﾞ'],
    ['ボ', 'ﾎﾞ'],
    ['パ', 'ﾊﾟ'],
    ['ピ', 'ﾋﾟ'],
    ['プ', 'ﾌﾟ'],
    ['ペ', 'ﾍﾟ'],
    ['ポ', 'ﾎﾟ'],
    ['ヴ', 'ｳﾞ'],
    ['ヷ', 'ﾜﾞ'],
    ['ヺ', 'ｦﾞ'],
    ['ア', 'ｱ'],
    ['イ', 'ｲ'],
    ['ウ', 'ｳ'],
    ['エ', 'ｴ'],
    ['オ', 'ｵ'],
    ['カ', 'ｶ'],
    ['キ', 'ｷ'],
    ['ク', 'ｸ'],
    ['ケ', 'ｹ'],
    ['コ', 'ｺ'],
    ['サ', 'ｻ'],
    ['シ', 'ｼ'],
    ['ス', 'ｽ'],
    ['セ', 'ｾ'],
    ['ソ', 'ｿ'],
    ['タ', 'ﾀ'],
    ['チ', 'ﾁ'],
    ['ツ', 'ﾂ'],
    ['テ', 'ﾃ'],
    ['ト', 'ﾄ'],
    ['ナ', 'ﾅ'],
    ['ニ', 'ﾆ'],
    ['ヌ', 'ﾇ'],
    ['ネ', 'ﾈ'],
    ['ノ', 'ﾉ'],
    ['ハ', 'ﾊ'],
    ['ヒ', 'ﾋ'],
    ['フ', 'ﾌ'],
    ['ヘ', 'ﾍ'],
    ['ホ', 'ﾎ'],
    ['マ', 'ﾏ'],
    ['ミ', 'ﾐ'],
    ['ム', 'ﾑ'],
    ['メ', 'ﾒ'],
    ['モ', 'ﾓ'],
    ['ヤ', 'ﾔ'],
    ['ユ', 'ﾕ'],
    ['ヨ', 'ﾖ'],
    ['ラ', 'ﾗ'],
    ['リ', 'ﾘ'],
    ['ル', 'ﾙ'],
    ['レ', 'ﾚ'],
    ['ロ', 'ﾛ'],
    ['ワ', 'ﾜ'],
    ['ヲ', 'ｦ'],
    ['ン', 'ﾝ'],
    ['ァ', 'ｱ'],
    ['ィ', 'ｲ'],
    ['ゥ', 'ｳ'],
    ['ェ', 'ｴ'],
    ['ォ', 'ｵ'],
    ['ッ', 'ﾂ'],
    ['ャ', 'ﾔ'],
    ['ュ', 'ﾕ'],
    ['ョ', 'ﾖ'],
    ['。', '｡'],
    ['、', '､'],
    ['ー', '-'],
    ['「', '｢'],
    ['」', '｣'],
    ['・', '･'],
    ['　', ' '],
  ])
  const reg = new RegExp('(' + Array.from(kanaMap.keys()).join('|') + ')', 'g')
  return text.replace(reg, (s: string) => kanaMap.get(s) ?? s)
}

/**
 * 全角記号を半角に変換
 * @param text
 * @returns
 */
export const symbolToHalfWidth = (text: string): string => {
  return text.replace(/[！-／：-＠［-｀｛-～]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0))
}

/**
 * 半角カナを全角に変換
 * @param text
 * @returns
 */
export const kanaToFullWidth = (text: string): string => {
  const kanaMap = new Map<string, string>([
    ['ｶﾞ', 'ガ'],
    ['ｷﾞ', 'ギ'],
    ['ｸﾞ', 'グ'],
    ['ｹﾞ', 'ゲ'],
    ['ｺﾞ', 'ゴ'],
    ['ｻﾞ', 'ザ'],
    ['ｼﾞ', 'ジ'],
    ['ｽﾞ', 'ズ'],
    ['ｾﾞ', 'ゼ'],
    ['ｿﾞ', 'ゾ'],
    ['ﾀﾞ', 'ダ'],
    ['ﾁﾞ', 'ヂ'],
    ['ﾂﾞ', 'ヅ'],
    ['ﾃﾞ', 'デ'],
    ['ﾄﾞ', 'ド'],
    ['ﾊﾞ', 'バ'],
    ['ﾋﾞ', 'ビ'],
    ['ﾌﾞ', 'ブ'],
    ['ﾍﾞ', 'ベ'],
    ['ﾎﾞ', 'ボ'],
    ['ﾊﾟ', 'パ'],
    ['ﾋﾟ', 'ピ'],
    ['ﾌﾟ', 'プ'],
    ['ﾍﾟ', 'ペ'],
    ['ﾎﾟ', 'ポ'],
    ['ｳﾞ', 'ヴ'],
    ['ﾜﾞ', 'ヷ'],
    ['ｦﾞ', 'ヺ'],
    ['ｱ', 'ア'],
    ['ｲ', 'イ'],
    ['ｳ', 'ウ'],
    ['ｴ', 'エ'],
    ['ｵ', 'オ'],
    ['ｶ', 'カ'],
    ['ｷ', 'キ'],
    ['ｸ', 'ク'],
    ['ｹ', 'ケ'],
    ['ｺ', 'コ'],
    ['ｻ', 'サ'],
    ['ｼ', 'シ'],
    ['ｽ', 'ス'],
    ['ｾ', 'セ'],
    ['ｿ', 'ソ'],
    ['ﾀ', 'タ'],
    ['ﾁ', 'チ'],
    ['ﾂ', 'ツ'],
    ['ﾃ', 'テ'],
    ['ﾄ', 'ト'],
    ['ﾅ', 'ナ'],
    ['ﾆ', 'ニ'],
    ['ﾇ', 'ヌ'],
    ['ﾈ', 'ネ'],
    ['ﾉ', 'ノ'],
    ['ﾊ', 'ハ'],
    ['ﾋ', 'ヒ'],
    ['ﾌ', 'フ'],
    ['ﾍ', 'ヘ'],
    ['ﾎ', 'ホ'],
    ['ﾏ', 'マ'],
    ['ﾐ', 'ミ'],
    ['ﾑ', 'ム'],
    ['ﾒ', 'メ'],
    ['ﾓ', 'モ'],
    ['ﾔ', 'ヤ'],
    ['ﾕ', 'ユ'],
    ['ﾖ', 'ヨ'],
    ['ﾗ', 'ラ'],
    ['ﾘ', 'リ'],
    ['ﾙ', 'ル'],
    ['ﾚ', 'レ'],
    ['ﾛ', 'ロ'],
    ['ﾜ', 'ワ'],
    ['ｦ', 'ヲ'],
    ['ﾝ', 'ン'],
    ['ｧ', 'ァ'],
    ['ｨ', 'ィ'],
    ['ｩ', 'ゥ'],
    ['ｪ', 'ェ'],
    ['ｫ', 'ォ'],
    ['ｯ', 'ッ'],
    ['ｬ', 'ャ'],
    ['ｭ', 'ュ'],
    ['ｮ', 'ョ'],
    ['｡', '。'],
    ['､', '、'],
    ['-', 'ー'],
    ['｢', '「'],
    ['｣', '」'],
    ['･', '・'],
  ])
  // 濁音・半濁音を優先的にマッチさせるため、長い文字列から順に処理
  const reg = new RegExp(
    '(' +
      Array.from(kanaMap.keys())
        .sort((a, b) => b.length - a.length)
        .join('|') +
      ')',
    'g',
  )
  return text.replace(reg, (s: string) => kanaMap.get(s) ?? s)
}

/**
 * 全ての Unicode ハイフン／ダッシュを
 * ASCII のハイフンマイナス（-）に正規化する
 */
const hyphenChars = [
  '\u002D', // HYPHEN-MINUS
  '\u00AD', // SOFT HYPHEN
  '\u058A', // ARMENIAN HYPHEN
  '\u05BE', // HEBREW PUNCTUATION MAQAF
  '\u1400', // CANADIAN SYLLABICS HYPHEN
  '\u1806', // MONGOLIAN TODO SOFT HYPHEN
  '\u2010', // HYPHEN
  '\u2011', // NON-BREAKING HYPHEN
  '\u2012', // FIGURE DASH
  '\u2013', // EN DASH
  '\u2014', // EM DASH
  '\u2015', // HORIZONTAL BAR
  '\u2053', // SWUNG DASH
  '\u207B', // SUPERSCRIPT MINUS
  '\u208B', // SUBSCRIPT MINUS
  '\u2212', // MINUS SIGN
  '\u2E17', // DOUBLE OBLIQUE HYPHEN
  '\u2E1A', // HYPHEN WITH DIAERESIS
  '\u2E3A', // TWO-EM DASH
  '\u2E3B', // THREE-EM DASH
  '\uFE63', // SMALL HYPHEN-MINUS
  '\uFF0D', // FULLWIDTH HYPHEN-MINUS
  '\uFF70', // HALFWIDTH KATAKANA-HIRAGANA PROLONGED SOUND MARK (半角カナ長音)
].join('')

/**
 * ハイフンを「-」に変換
 * @param text
 * @returns
 */
export const normalizeToHyphen = (text: string): string => {
  const hyphenRegex = new RegExp(`[${hyphenChars}]`, 'g')
  // ハイフンを'-'に置き換え
  return text.replace(hyphenRegex, '-')
}

/**
 * 半角文字に変換
 * @param text
 * @param whiteSpace `trim`=半角スペースをトリム(前後スペースと連続する空白の削除)、`all-trim`=空白をすべて削除
 * @returns
 */
export const toHalfWidth = (text: string, whiteSpace: 'trim' | 'all-trim' = 'trim'): string => {
  const optimized1 = englishNumberToHalfWidth(text)
  const optimized2 = kanaToHalfWidth(optimized1)
  const optimized3 = symbolToHalfWidth(optimized2)
  const optimized4 = normalizeToHyphen(optimized3)
  if (whiteSpace === 'all-trim') {
    return optimized4.replace(/[\s]+/g, '')
  } else {
    return optimized4.trim().replace(/[\s]+/g, ' ')
  }
}
